const API_BASE = process.env.REACT_APP_API_URL || '';

const buildUrl = (path, params) => {
    const url = new URL(`${API_BASE}${path}`, window.location.origin);
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            url.searchParams.set(key, value);
        }
    });
    return url.toString();
};

const authHeaders = (extra = {}) => {
    const headers = { ...extra };
    const token = localStorage.getItem('user_authToken');
    if (token) headers.Authorization = `Bearer ${token}`;
    return headers;
};

const parseResponse = async (response) => {
    const text = await response.text();
    const json = text ? JSON.parse(text) : null;
    if (!response.ok) {
        throw new Error(json?.error || response.statusText || 'Request failed');
    }
    return {
        json,
        total: Number(response.headers.get('X-Total-Count') || 0),
    };
};

export const apiGet = async (path, params) => {
    const response = await fetch(buildUrl(path, params), {
        headers: authHeaders({ Accept: 'application/json' }),
    });
    return parseResponse(response);
};

export const apiPost = async (path, body) => {
    const response = await fetch(buildUrl(path), {
        method: 'POST',
        headers: authHeaders({
            Accept: 'application/json',
            'Content-Type': 'application/json',
        }),
        body: JSON.stringify(body || {}),
    });
    return parseResponse(response);
};

export const apiPut = async (path, body) => {
    const response = await fetch(buildUrl(path), {
        method: 'PUT',
        headers: authHeaders({
            Accept: 'application/json',
            'Content-Type': 'application/json',
        }),
        body: JSON.stringify(body || {}),
    });
    return parseResponse(response);
};

export const apiDelete = async (path) => {
    const response = await fetch(buildUrl(path), {
        method: 'DELETE',
        headers: authHeaders({ Accept: 'application/json' }),
    });
    if (response.status === 204) return { json: null, total: 0 };
    return parseResponse(response);
};

export const apiUpload = async (path, formData) => {
    const response = await fetch(buildUrl(path), {
        method: 'POST',
        headers: authHeaders({ Accept: 'application/json' }),
        body: formData,
    });
    return parseResponse(response);
};

const filenameFromDisposition = (disposition, fallback) => {
    if (!disposition) return fallback;
    const encoded = disposition.match(/filename\*=UTF-8''([^;]+)/i);
    if (encoded?.[1]) {
        try {
            return decodeURIComponent(encoded[1]);
        } catch (error) {
            return fallback;
        }
    }

    const plain = disposition.match(/filename="?([^"]+)"?/i);
    return plain?.[1] || fallback;
};

export const apiDownload = async (path, fallbackFilename = 'download.xlsx') => {
    const response = await fetch(buildUrl(path), {
        headers: authHeaders({ Accept: 'application/octet-stream' }),
    });

    if (!response.ok) {
        const text = await response.text();
        let json = null;
        try {
            json = text ? JSON.parse(text) : null;
        } catch (error) {
            json = null;
        }
        throw new Error(json?.error || response.statusText || 'Download failed');
    }

    const blob = await response.blob();
    const filename = filenameFromDisposition(response.headers.get('Content-Disposition'), fallbackFilename);
    const objectUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.setTimeout(() => URL.revokeObjectURL(objectUrl), 0);
};
